/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const SquareArrowIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <rect x="0.5" y="14.5" width="9" height="9" />
      <path d="M11.5,12.5 L23.5,0.5" />
      <polyline points="17.5 0.5 23.5 0.5 23.5 6.5" />
    </g>
  </svg>
);

export default SquareArrowIcon;
